<template>
<div class="h-full w-full min-h-screen relative" >
  <Container back_ground_color='md:p-20 sm:p-20 h-full xs:p-0 xs:bg-white '>
      <Modalchecker 
      v-show="show_message_modal" 
      v-bind:display="show_message_modal"
      :error="this.error"
      :success="this.success"
      :note="this.warning">
        <div class="w-full p-5 flex flex-col text-xl font-bold">
              Thank you for re-submitting your requirements!
          </div>
      </Modalchecker>
      <img src="@/assets/images/WEB2.jpg" class="fixed h-screen w-full  "/>
  </Container>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import 'ant-design-vue/dist/antd.css';
import Modalchecker from '@/components/controls/ModalControl.vue'
export default defineComponent({
  components:{
    Modalchecker
  },
  data(){
    return {
      error:false,
      warning:false,
      success:false,
      show_message_modal:false,
    }
  },
  mounted(){
    this.success = true;
    this.show_message_modal = true;
  }
})
</script>

<style>
.max-height-container {
  max-height: 80% !important;
}
.ant-steps-item-title{
  font-size: 20px !important;
}
.bg-translucent {
    background-color: rgba(0 ,0 ,0 ,0.75);
}
</style>
